import { Alert, FlatList, LogBox, Pressable, StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native"
import { GenderSelect, MyButton, TextInputTemp } from "../buttonsAndControls";
import { useEffect, useMemo, useState } from "react";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { IconButton, Modal, Portal } from "react-native-paper";
import { useNavigation } from '@react-navigation/native';
import { last } from "pdf-lib";
import Registration from "../registration";
import DateModule from "../DateModule";
import { branch, companyDir, regModal, stopCodes } from "../StockAwareTempData";
import DropDownPicker from "react-native-dropdown-picker";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, query, updateDoc, where } from "firebase/firestore";
import createAndSavePDF from "../pdfCreate";
import { getStorage, ref, listAll, getDownloadURL, deleteObject } from "firebase/storage";



const darkColour='#2a2d3e';

interface Data {
  id: string;
  texts: string[];
}

interface Company {
 companyName: string;
 address: string;
 phone1: string;
 phone2: string;
}

interface Employee {
  ID: number
  Firstname: string;
  Middlename: string;
  Lastname: string;
  Phone_Number: string;
  Username: string;
  Password: string;
  Avatar: string;
  Date_of_Employment: string;
  BirthDate: string;
  Gender: string;
  Address: string;
  AppUser: string;
  Salary: number;
}

interface EmployeeData {
  regID: string;
  firstname: string;
  middlename: string;
  lastname: string;
  phone: string;
  username: string;
  password: string;
  avarta: string;
  doe: string;
  dob: string;
  gender: string;
  address: string;
  appUser: boolean;
  salary: number;
}

interface RegData {
  username: string;
  password: string;
  avarta: string;
}

const EmployeeView = ({texts, isChecked, onEditPressed, index, delPressed,
}: Data & { isChecked: boolean; onEditPressed: () => void; index: number; delPressed: () => void}) => {
  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const [hovered, setHovered] = useState(false);
  const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [320, 150, 500, 150, 80, 100, 100];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity style={{backgroundColor:'transparent'}}>
        <Pressable style={{...styles.childTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
          onHoverIn={() => setHovered(true)}
          onHoverOut={() => setHovered(false)}
          onPressIn={() => setIsOpacity(true)}
          onPressOut={() => setIsOpacity(false)}
          >
      
          {texts.map((text, i) => (
            <View key={i} style={{...styles.childBoxes, width: sizes[i]}}>
              <Text key={i} style={{...styles.childText,  color: darkColour}}>
                {text}
              </Text>
            </View>
          ))}

          <View style = {{width: 65, borderWidth: 2, height: 35, marginLeft: -2, padding: 3, justifyContent: 'center'}}>
            <View>
              <MyButton btnText="Edit" btnHeight={25} disabled = {isChecked} 
                btnWidth={55} btnBorRadius={3} btnPadding={4} btnFontSize={14} hndClicked={onEditPressed} 
              />
            </View>
          </View>
          {hovered && (
          <IconButton icon={'trash-can-outline'} size={25} focusable={true} iconColor={darkColour}  
            style={styles.iconButtonStyle}
            onPress={() => delPressed()}
            onHoverIn={() => setHovered(true)}
            onHoverOut={() => setHovered(false)}
          />
          )}
        </Pressable>
      </TouchableOpacity>
    </View>
  );
};

export const CompanyData = () => {

  const [iD, setID] = useState('');
  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddlename] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [salary, setSalary] = useState('');
  const [address, setAddress] = useState('');
  const [isEditable, setIsEditable] = useState(false);
  const [newEmployee, setNewEmployee] = useState(false);
  const [birthDate, setBirthDate] = useState('')
  const [gender, setGender] = useState('')
  const [appUser, setAppUser] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [avatar, setAvatar] = useState('');
  const [editCompanyModal, setEditCompanyModal] = useState(false)
  const [companyName, setCompanyName] = useState('');
  const [companyPhone, setCompanyPhone] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [mCompanyName, setMCompanyName] = useState('');
  const [mPhone1, setMPhone1] = useState('');
  const [mPhone2, setMPhone2] = useState('');
  const [mAddress, setMAddress] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [appUsersNumber, setAppUsersNumber] = useState('');
  const [monthlySalary, setMonthlySalary] = useState('');
  const [employeeList, setEmployeeList] = useState<Employee[]>([]);
  const [companyData, setCompanyData] = useState<Company[]>([]);
  const [phone1Setter, setPhone1Setter] = useState('')
  const [phone2Setter, setPhone2Setter] = useState('')
  const [showReg, setShowReg] = useState(false)
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([
    {label: 'Male', value: 'Male', icon: () => <IconButton icon="human-male" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'Female', value: 'Female', icon: () => <IconButton icon="human-female" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}
  ]);
  const [reload, setReload] = useState('');
  const result = [];
  const [employees, setEmployees] = useState<EmployeeData[]>([]);
  const currentDate = new Date();
  const year = currentDate.getFullYear(); // e.g., 2023
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // e.g., 09 (months are 0-based)
  const day = String(currentDate.getDate()).padStart(2, '0'); // e.g., 30
  const formattedDate = `${year}-${month}-${day}`;
  const db = getFirestore();


  
  
  // const fstore = firestore();





  const loadEmployees = async () => {
    // Create a reference to the 'Employees' collection
    const employeesCollection = collection(db, companyDir, branch, 'employee');
    const employeeArrayData: EmployeeData[] = [];
    (async () => {
      // Get all employees
      const employeesQuery = query(employeesCollection);
      const employeesSnapshot = await getDocs(employeesQuery);
      let _salary = 0;
      let _appUsers = 0;
      // Iterate through employees
      for (const employeeDoc of employeesSnapshot.docs) {
        const employeeData = employeeDoc.data();
        // Create a reference to the 'Registrations' collection
        const usersCollection = collection(db, 'users');

        // Query registrations for this employee
        const registrationQuery = query(
          usersCollection,
          where('regID', '==', employeeDoc.id)
        );
        const registrationSnapshot = await getDocs(registrationQuery);
        const registrationData = ({ username: '', password: '', avarta: '' })
        // If a registration exists, merge its data
        if (!registrationSnapshot.empty) {
          registrationSnapshot.forEach((registrationDoc) => {
            registrationData.username = registrationDoc.data().username;
            registrationData.password = registrationDoc.data().password;
            registrationData.avarta = registrationDoc.data().avarta;
          });
        }
        const mergedData = {
          // regID: employeeDoc.id,
          // firstname: employeeDoc.data().firstname,
          // middlename: employeeDoc.data().middlename,
          // lastname: employeeDoc.data().lastname,
          // phone: employeeDoc.data().phone,
          // username: registrationData.username,
          // password: registrationData.password,
          // avarta: registrationData.avarta,
          // doe: employeeDoc.data().doe,
          // dob: employeeDoc.data().dob,
          // gender: employeeDoc.data().gender,
          // address: employeeDoc.data().address,
          // appUser: employeeDoc.data().appUser,
          // salary: employeeDoc.data().salary
          ...employeeData,
          ...registrationData,
          regID: employeeDoc.id,
        };
        result.push(mergedData);
        employeeArrayData.push(mergedData as unknown as EmployeeData)

        _salary += Number(employeeData.salary)
        if (employeeData.appUser === true) {
          _appUsers += 1
        }
      }
      setEmployees(employeeArrayData);
      setEmployeeNumber(employeeArrayData.length.toString());
      setMonthlySalary(_salary.toString());
      setAppUsersNumber(_appUsers.toString())
    })()
  }

  const clearData = () => {
    setID('');
    setFirstname('');
    setMiddlename('');
    setLastname('');
    setPhone('');
    setSalary('');
    setBirthDate('');
    setGender('');
    setUsername('');
    setPassword('')
    setAvatar('');
    setAddress('');
    setAppUser(false);
    setIsEditable(false);
  }

  const CreateTable = async () => {

    await loadEmployees();

    const db = getFirestore();
    const companySnapshot = await getDocs(collection(db, companyDir, branch, 'company'))
    if (companySnapshot.size > 0) {
      setCompanyName(companySnapshot.docs[0].data().companyName)
      setCompanyAddress(companySnapshot.docs[0].data().address)
      let _companyPhone = '';
      let _phone1 = '';
      let _phone2 = '';
      if (companySnapshot.docs[0].data().phone1 && companySnapshot.docs[0].data().phone2) {
        _phone1 = companySnapshot.docs[0].data().phone1;
        _phone2 = companySnapshot.docs[0].data().phone2
        _companyPhone = companySnapshot.docs[0].data().phone1 + ', ' + companySnapshot.docs[0].data().phone2;
      } else if (companySnapshot.docs[0].data().phone1) {
        _phone1 = companySnapshot.docs[0].data().phone1;
        _companyPhone = companySnapshot.docs[0].data().phone2;
      } else if (companySnapshot.docs[0].data().phone2) {
        _phone2 = companySnapshot.docs[0].data().phone2;
        _companyPhone = companySnapshot.docs[0].data().phone2;
      }
      setCompanyPhone(_companyPhone);
      setPhone1Setter(_phone1);
      setPhone2Setter(_phone2);
    }
  }

  const data = {
    firstname: firstname,
    middlename: middlename,
    lastname: lastname,
    phone: phone,
    gender: gender,
    address: address,
  }

  const reloadEmployee = async() => {
    let date = ''
    if (birthDate.split('-')[0]) {
      date = birthDate
    } else {
      date = '1111-01-11';
    }

    const updatedData = {
      ...data,
      dob: date,
      salary: salary
    }

    const docRef = doc(getFirestore(), companyDir, branch, 'employee', iD);
    const docSnapshot = await getDoc(docRef);
    if (docSnapshot) {
      try {
        await updateDoc(docRef, updatedData);
        clearData();
      } catch (error) {
        window.confirm(`Failed to update`);
      }
    }

    loadEmployees();
  }

  const addNewEmployee = async () => {
    if (firstname.trim() === '' || lastname.trim() === '' || address.trim() === '') {
      window.confirm(`Failed, fundamentals missing.\nFirst name, last name or address fields are mandatory, \nyou must fill these fields.`);
    } else {
      let date = ''
      if (birthDate.split('-')[0]) {
        date = birthDate
      } else {
        date = '1111-01-11';
      }
      const regData = {
        ...data,
        dob: date
      }

      const empData = {
        ...data,
        dob: date,
        salary: salary
      }

      const newEmpData = {
        ...data,
        dob: date,
        company: companyDir,
        branch: branch,
        doe: formattedDate,
        appUser: false,
        salary: salary
      }
      if (!newEmployee && isEditable) {
        if (appUser === true) {
          const docRef = doc(getFirestore(), 'users', iD);
          const docSnapshot = await getDoc(docRef);
          if (docSnapshot) {
            try {
              await updateDoc(docRef, regData);
              window.confirm(`${firstname} ${lastname}'s  data has been updated successfully.`);
            } catch (error) {
            }
          }
        }

        const docRef = doc(getFirestore(), companyDir, branch, 'employee', iD);
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot) {
          try {
            await updateDoc(docRef, empData);
            window.confirm(`${firstname} ${lastname}'s  data has been updated successfully.`);
            clearData();
          } catch (error) {
            window.confirm(`Failed to update`);
          }
        }
        loadEmployees()
      } else {
        try {
          await addDoc(collection(getFirestore(), companyDir, branch, "employee"), newEmpData);
          window.confirm(`${firstname} ${lastname} has successfully been added to employees.`);
          clearData();
        } catch (error) {
          window.confirm(`Failed to add to app users.`);
        }
        loadEmployees()
      }
    }
  }

  useEffect(() => {
    if (stopCodes) {
      CreateTable();
    }
  }, [stopCodes])

  useEffect(() => {
  }, [result]);

  useEffect(() => {
    if (firstname.trim() !== '' || lastname.trim() !== '' || address.trim() !== '') {
      reloadEmployee();
      setReload('');
    }
  }, [reload === 'Yes']);

  const handleFistname = (text: string) => {
    setFirstname(text)
  }

  const handleMiddlename = (text:string) => {
    setMiddlename(text)
  }

 const handleLastname = (text:string) => {
    setLastname(text)
  }

  const handlePhone = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setPhone(digitsOnly)
  }

  const handleSalary = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setSalary(digitsOnly)
  }

  const handleAddress = (text:string) => {
    setAddress(text)
  }

  const handleMCompanyName = (text: string) => {
    setMCompanyName(text)
  }

  const handleMPhone1 = (text:string) => {
    setMPhone1(text)
  }

  const handleMPhone2 = (text:string) => {
    setMPhone2(text)
  }

  const handleOnEditPressed = (data: EmployeeData) => {
    console.log(data)
    setIsEditable(true);
    setNewEmployee(false);
    setID(data.regID);
    setFirstname(data.firstname);
    setMiddlename(data.middlename);
    setLastname(data.lastname);
    setUsername(data.username);
    setPassword(data.password);
    setAvatar(data.avarta);
    setPhone(data.phone);
    setAddress(data.address);
    data.dob?.split('-')[0] === '1111' ? setBirthDate('') : setBirthDate(data.dob);
    setGender(data.gender);
    setSalary(data.salary.toString());
    setAppUser(data.appUser);
  }

  const handleCancel = () => {
    setIsEditable(false)
    setID('');
    setFirstname('');
    setMiddlename('');
    setLastname('');
    setPhone('');
    setAddress('');
    setBirthDate('');
    setGender('');
    setUsername('');
    setPassword('')
    setAvatar('');
    setSalary('');
    setAppUser(false);
  };

  const handleBirthDate = (day: string, month: string, year: string) => {
    setBirthDate(year + '-' + month + '-' + day)
  }

  const onClickFromReg = (text: string) => {
    setShowReg(false); 
    setReload(text)
  }

  const deleteItem = (id: string, isAppUser: boolean, fName: string, lName: string) => {
    if (isAppUser === true) {
      const dialogResult = window.confirm(`App User & Employee Deletion\nAre you sure to delete ${fName} ${lName} from app users and employee?`);
      if (dialogResult === true) {
        handleUserDeletion(id)
      } 
    } else {
      const dialogResult = window.confirm(`Employee Deletion\nAre you sure to delete ${fName} ${lName} from employee?`);
      if (dialogResult === true) {
        handleUserDeletion(id)
      } 
    }
  };

  const handleUserDeletion = async (regId: string) => {
    try {
      const myCollection = collection(getFirestore(), 'users');
      const q = query(myCollection, where('regID', '==', regId));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.size > 0) {
        const docRef = querySnapshot.docs[0].ref;
        deleteDoc(docRef);
      }
    } catch (error) {
      console.error("Error deleting document: ", error);
    }

    const delDocRef = doc(getFirestore(), companyDir, branch, "employee", regId);
    const docSnapshot = await getDoc(delDocRef);
    if (docSnapshot.exists()) {
      const fName = firstname;
      const lName = lastname;
      try {
        deleteDoc(delDocRef);
        window.confirm(`Deletion Successful.\n${fName} ${lName} has been deleted.`);
        loadEmployees();
        handleCancel();
      } catch (error) {
        window.confirm(`Failed to delete this employee.`);
      }
    }
  }

  const clearCompanyModal = () => {
    let _companyPhone = '';
    if (mPhone1 && mPhone2) {
      _companyPhone = mPhone1 + ', ' + mPhone2;
    } else if (mPhone1) {
      _companyPhone = mPhone1;
    } else if (mPhone2) {
      _companyPhone = mPhone2;
    }
    setCompanyName(mCompanyName);
    setCompanyAddress(mAddress);
    setCompanyPhone(_companyPhone)
    setPhone1Setter(mPhone1);
    setPhone2Setter(mPhone2);
    setMCompanyName('');
    setMAddress('');
    setMPhone1('');
    setMPhone2('');
  }

  const companyDataToAdd = {
    companyName: mCompanyName,
    address: mAddress,
    phone1: mPhone1,
    phone2: mPhone2,
  };

  const handleCompanyData = async() => {
    const hasNonDigit1 = /[^0-9]/.test(mPhone1);
    const hasNonDigit2 = /[^0-9]/.test(mPhone2);
    if (mCompanyName.trim() === '') {
      window.confirm(`Error on Company Name.\nCompany must have a name, which is also included in receipts.`);
      return;
    }
    if (mAddress.trim() === '') {
      window.confirm(`Error on Company Address.\nIt is mandatory you fill the company address column. This is used by receipts.`);
      return;
    }
    if (mPhone1.trim() === '' && mPhone2.trim() === '') {
      window.confirm(`Error on Phone Number.\nCompany must have at least one phone number.`);
      return;
    }
    if (hasNonDigit1 || hasNonDigit2) {
      window.confirm(`Error on Phone Number.\nPhone number must be a number between 0 to 9.`);
      return;
    } else {
      const currentCompany = query(collection(db, companyDir, branch, 'company'), where('companyName', '==', companyDir));

      const querySnapshot = await getDocs(currentCompany);

      if (querySnapshot.size > 0) {
        const docRef = querySnapshot.docs[0].ref;
        await updateDoc(docRef, companyDataToAdd);
        window.alert( 'Successful\nCompany data updated successfully.')
        setEditCompanyModal(false);
        clearCompanyModal();
      } else {
        addDoc(collection(db, companyDir, branch, 'company'), companyDataToAdd);
        window.alert( 'Successful\nCompany data added successfully')
        setEditCompanyModal(false);
        clearCompanyModal();
      }
    }
  }

  const salesData: { qty: string; desc: string; amt: string; }[] = [];
  const receiptData = ({
    name: '', address: '', phone: '', salesID: '', salesPerson: '', date: '', payment: '', customer: '', total: '', discount: '', totalPaid: ''
  })
  
  const handleShowCompanyModal = async () => {
    setMCompanyName(companyName);
    setMAddress(companyAddress);
    setMPhone1(phone1Setter);
    setMPhone2(phone2Setter)
    setEditCompanyModal(true)
  }

  const MemoizedRegistration = useMemo(() =>  <Registration _regID= {iD} _firstname= {firstname} _middlename= {middlename} _lastname= {lastname} _birthDate= {birthDate} 
    _username= {'Custom'} _password= {password} _avatar= {avatar} _gender= {gender} _phone= {phone} 
    _address= {address} showModal = {showReg} onClicked={()=> setShowReg(false)} isEdit = {false}
  />, []);

  return (
    <View>
      <View style = { styles.row }>
        <View style = {{marginVertical: 5, flex:1}}>
          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              Company Name:
            </Text>
            <Text style = { styles.companyTextBold}>
              {companyName}
            </Text>
          </View>
          <View style = {{...styles.smallBox, height: 60}}>
            <Text style = {{...styles.companyText, alignSelf: 'flex-start', marginTop: 5}}>
              Address:
            </Text>
            <Text style = {{...styles.companyTextBold, alignSelf: 'flex-start', marginTop: 5, width: 400,  flexWrap: 'wrap', textAlign: 'left'}} numberOfLines={3}>
              {companyAddress}
            </Text>
          </View>
          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              Phone:
            </Text>
            <Text style = { styles.companyTextBold}>
              {companyPhone}
            </Text>
          </View>
          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              Number of Employees:
            </Text>
            <Text style = { styles.companyTextBold}>
              {employeeNumber}
            </Text>
          </View>
          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              App Users:
            </Text>
            <Text style = { styles.companyTextBold}>
              {appUsersNumber}
            </Text>
          </View>
          <View style = { styles.row }>
            <View style = {{...styles.smallBox, width: 300}}>
              <Text style = { styles.companyText}>
                Monthly Salaries:
              </Text>
              <Text style = { styles.companyTextBold}>
              {Number(monthlySalary).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
              </Text>
            </View>
            <View style = {{marginTop: 3, marginRight: 10}}>
              <MyButton btnText= "Edit Company Info"
                btnBorClr= 'white'
                btnBorRadius={10}
                btnColor= {darkColour}
                btnFontSize={15}
                btnHeight={40}
                btnWidth={188}
                btnTxtClr={'white'}
                btnPadding={10}
                hndClicked={()=> {handleShowCompanyModal()}}
              />
            </View>
          </View>

          <Portal>
            <Modal visible = {editCompanyModal} contentContainerStyle={{width:525, height: 300, backgroundColor:'white', borderWidth:2, borderColor:darkColour, borderRadius:10, marginTop: -430, marginLeft:700}} onDismiss={()=> setEditCompanyModal(false)}>
              <Text style = {{...styles.companyTextBold, fontSize: 18, marginVertical: 20 }}>
                Company Details
              </Text>

              <View style = {styles.smallBox}>
                <Text style = { styles.companyText}>
                  Company Name:
                </Text>
                <TextInput style = {styles.editStyle} defaultValue = {companyName} onChangeText={handleMCompanyName} />
              </View>

              <View style = {{...styles.smallBox, height: 60}}>
                <Text style = {{...styles.companyText, alignSelf: 'flex-start', marginTop: 5 }}>
                  Address:
                </Text>
                <TextInput style = {{...styles.editStyle, flexWrap: 'wrap', height: 60}}
                  numberOfLines={3} multiline defaultValue = {companyAddress} onChangeText={(value)=> setMAddress(value)} 
                />
              </View>

              <View style = {styles.smallBox}>
                <Text style = { styles.companyText}>
                  Phone Number 1:
                </Text>
                <TextInput style = {styles.editStyle} defaultValue = {phone1Setter} onChangeText={(value)=> {handleMPhone1(value)}}/>
              </View>

              <View style = {styles.row}>
                <View style = {{...styles.smallBox, width: 340}}>
                  <Text style = { styles.companyText}>
                    Phone Number 2:
                  </Text>
                  <TextInput style = {styles.editStyle} defaultValue = {phone2Setter} onChangeText={(value)=> {handleMPhone2(value)}}/>
                </View>
                <View style = {{marginTop: 3, marginRight: 10}}>
                  <MyButton btnText= "Save"
                    btnBorClr= 'white'
                    btnBorRadius={10}
                    btnColor= {darkColour}
                    btnFontSize={15}
                    btnHeight={40}
                    btnWidth={150}
                    btnTxtClr={'white'}
                    btnPadding={10}
                    hndClicked={()=> {handleCompanyData()}}
                  />
                </View>
              </View>
            </Modal>
          </Portal>
        </View>

        <View style = { styles.editEmployee}>
          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              First Name:
            </Text>
            <TextInput style = {styles.editStyle} value= {firstname} onChangeText={handleFistname} editable = {isEditable} />
          </View>

          <View style = {styles.smallBox}>
            <Text style = {styles.companyText}>
              Middle Name:
            </Text>
            <TextInput style = {styles.editStyle} value= {middlename} onChangeText={handleMiddlename} editable = {isEditable} />
          </View>

          <View style = {styles.smallBox}>
            <Text style = { styles.companyText}>
              Last Name:
            </Text>
            <TextInput style = {styles.editStyle} value= {lastname} onChangeText={handleLastname} editable = {isEditable} />
          </View>
          
          <View style = {styles.row}>
            <View style = {{...styles.smallBox, width: 260}}>
              <Text style = { styles.companyText}>
                Phone:
              </Text>
              <TextInput style = {styles.editStyle} value= {phone} onChangeText={handlePhone} editable = {isEditable} />
            </View>
            <View style = {{...styles.smallBox, width: 220}}>
              <Text style = {styles.companyText}>
                Salary (₦):
              </Text>
              <TextInput style = {{...styles.editStyle, width: 100}} value= {salary} onChangeText={handleSalary} editable = {isEditable} />
            </View>
          </View>

          <View style = {{...styles.smallBox, height: 60}}>
            <Text style = {{...styles.companyText, alignSelf: 'flex-start', marginTop: 5 }}>
              Address:
            </Text>
            <TextInput style = {{...styles.editStyle, flexWrap: 'wrap', height: 60}} 
              numberOfLines={3} multiline value= {address} onChangeText={handleAddress} editable = {isEditable} autoCapitalize="words" spellCheck = {false}
            />
          </View>

          
          <View style = {{...styles.row, flex:1, alignItems: 'flex-end', marginBottom: 5}}>
            {isEditable && !newEmployee &&
              <View style = {{marginTop: 3, marginRight: 10}}>
                <MyButton btnText= "Delete"
                  btnBorClr= 'white'
                  btnBorRadius={10}
                  btnColor= {darkColour}
                  btnFontSize={15}
                  btnHeight={40}
                  btnWidth={100}
                  btnTxtClr={'white'}
                  btnPadding={10}
                  hndClicked={()=> {deleteItem(iD.toString(), appUser, firstname, lastname)}}
                />
              </View>
            }
            {isEditable && !newEmployee &&
              <View style = {{marginTop: 3, marginRight: 10}}>
                <MyButton btnText= {appUser === true ? 'Edit App User' : 'Add to App Users'}
                  btnBorClr= 'white'
                  btnBorRadius={10}
                  btnColor= {darkColour}
                  btnFontSize={15}
                  btnHeight={40}
                  btnWidth={170}
                  btnTxtClr={'white'}
                  btnPadding={10}
                  hndClicked={()=> {setShowReg(true)}}
                />
              </View>

            }
            {isEditable &&
              <View style = {{marginTop: 3, marginRight: 10}}>
                <MyButton btnText= "Cancel"
                  btnBorClr= {darkColour}
                  btnBorWdt={2}
                  btnBorRadius={10}
                  btnColor= {'white'}
                  btnFontSize={15}
                  btnHeight={40}
                  btnWidth={100}
                  btnTxtClr={darkColour}
                  btnPadding={10}
                  hndClicked={()=> {handleCancel()}}
                />
              </View>
            }
            {isEditable &&
              <View style = {{marginTop: 3, marginRight: 10}}>
                <MyButton btnText= {newEmployee ? "Save" : 'Update'}
                  btnBorClr= 'white'
                  btnBorRadius={10}
                  btnColor= {darkColour}
                  btnFontSize={15}
                  btnHeight={40}
                  btnWidth={100}
                  btnTxtClr={'white'}
                  btnPadding={10}
                  hndClicked={()=> {addNewEmployee()}}
                />
              </View>
            }
            {!isEditable &&
              <View style = {{marginTop: 3, marginRight: 10}}>
                <MyButton btnText= "Add New Employee"
                  btnBorClr= 'white'
                  btnBorRadius={10}
                  btnColor= {darkColour}
                  btnFontSize={15}
                  btnHeight={40}
                  btnWidth={200}
                  btnTxtClr={'white'}
                  btnPadding={10}
                  hndClicked={()=> {setIsEditable(true); setNewEmployee(true)}}
                />
              </View>
            }
          </View>
        </View>
      </View>
      {showReg &&
        <Registration _regID= {iD} _firstname= {firstname} _middlename= {middlename} _lastname= {lastname} _birthDate= {birthDate} 
          _username= {username} _password= {password} _avatar= {avatar} _gender= {gender} _phone= {phone} _newBranch = {false}
          _address= {address} showModal = {showReg} onClicked={onClickFromReg} isEdit = {false} _branchName= {branch}
        />
      }
      <View>
        <View>
          <View style={styles.secondBoxHeader}>
            <View style={{ ...styles.columnHeaderBox, width: 320, marginLeft: 0, borderLeftWidth: 0 }}>
              <Text style={{ ...styles.columnHeaderText }}>Name</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 150}}>
              <Text style={{ ...styles.columnHeaderText }}>Phone Number</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 500 }}>
              <Text style={{ ...styles.columnHeaderText }}>Address</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 150 }}>
              <Text style={{ ...styles.columnHeaderText }}>Employed Date</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 80 }}>
              <Text style={{ ...styles.columnHeaderText }}>App User</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 100 }}>
              <Text style={{ ...styles.columnHeaderText }}>Salary (₦)</Text>
            </View>
            <View style={{ ...styles.columnHeaderBox, width: 40, borderRightWidth: 0 }}>
              <Text style={{ ...styles.columnHeaderText }}></Text>
            </View>
          </View>
          <View style = {{  width: 1382, height: 315, marginHorizontal: 10, backgroundColor:'white',}}>
            <FlatList
                data={employees}
                keyExtractor={(item) => item.regID}
                renderItem={({ item, index }) => (
                  <EmployeeView
                    key={item.regID}
                    texts={[
                      `${item.firstname} ${item.lastname}`,
                      item.phone,
                      item.address?.toString(),
                      item.doe?.toString(),
                      item.appUser?.toString(),
                      Number(item.salary)?.toLocaleString('en-NG'),
                    ]}
                    isChecked={isEditable}
                    onEditPressed={() => {handleOnEditPressed(item)}}
                    index={index}
                    id={item.regID}
                    delPressed={()=> {deleteItem(item.regID, item.appUser, item.firstname, item.lastname)}}
                  />
                )}
              />
          </View>

          <View style = {styles.boxFooterText}>
               
          </View>
        </View>
      </View>

      <View style = {{...styles.row, marginTop: 254, marginLeft: 895, position: 'absolute'}}>
        <View style={{ flexDirection:'row', marginTop: 4}}>
          <View style={{...styles.dateTextContainer, borderColor: darkColour}}>
            <Text style={{...styles.birthDateText, color: 'white'}}>Birth Date</Text>
          </View>
          <DateModule 
            appearUp = {false} 
            dateReset = {isEditable} 
            onNewDateSelected= {handleBirthDate} 
            _day= {birthDate ? birthDate.split('-')[2] : undefined} 
            _month= {birthDate ? birthDate.split('-')[1] : undefined} 
            _year= {birthDate ? birthDate.split('-')[0] : undefined}
          />
          <View style = {{marginLeft: 13}}>
            <View style={{width:200, height:40}}>
              <DropDownPicker
                disabled = {!isEditable}
                theme="DARK"
                modalAnimationType='slide'
                placeholder='Gender'
                style={{borderRadius:10, borderWidth:1, height: 40, borderColor: darkColour}}
                open={open}
                value={gender}
                items={items}
                setOpen={setOpen}
                setValue={setGender}
                setItems={setItems}
                listItemContainerStyle={{backgroundColor:'white'}}
                listItemLabelStyle={{color:'black', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                textStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                placeholderStyle={{color: 'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300', textAlign:'center'}}
              />
            </View>
          </View>
          
        </View>          
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row'
  },
  smallBox: {
    borderWidth: 2,
    borderColor: '#DCE3E8',
    borderRadius: 10,
    width: 500,
    height: 40,
    backgroundColor: 'white',
    margin: 10,
    marginVertical: 3,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  companyText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color: darkColour,
    marginHorizontal: 10,
  },
  companyTextBold: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'600', 
    textAlign:'center',
    color: darkColour,
  },
  secondBoxHeader: {
		width: 1382,
		height: 35,
    marginHorizontal: 10,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
  editStyle: {
    borderTopRightRadius: 10, 
    borderBottomRightRadius: 10, 
    height: 40, 
    width: 350, 
    fontSize: 15, 
    fontFamily: 'century gothic', 
    padding: 11,
    paddingHorizontal: 5,
    flex: 1
  },
  columnHeaderBox: {
    paddingTop:2,
    borderWidth:2, 
    borderColor:'black', 
    width:57,  
    height:'100%', 
    alignItems:'center',
    borderTopWidth:0,
    marginLeft:-2,
  },
  columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
    },
  boxFooterText: {
    width: 1400, 
    height: 40, 
    flexDirection: 'row', 
    backgroundColor: darkColour, 
    borderBottomRightRadius: 10, 
    borderBottomLeftRadius: 10, 
    justifyContent: 'flex-start',
    marginHorizontal: 10
  },
  editEmployee: {
    borderColor: '#DCE3E8',
    borderRadius: 10,
    width:540,
    height: 350,
    //backgroundColor: 'white',
    //margin: 10,
    marginVertical: 3,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    marginTop: 5,
    
    
  },
  addressTextContainer: {
    width:150, 
    height: 40, 
    borderTopLeftRadius:10, 
    borderBottomLeftRadius:10, 
    backgroundColor:darkColour, 
    borderWidth:1, 
    borderRightWidth:0
  },
  addressLabel: {
    color: 'white', 
    fontFamily:'century gothic', 
    fontSize:16, 
    padding:10, paddingHorizontal:5, 
    fontWeight:'normal', 
    alignSelf:'center',
    verticalAlign:'middle'
  },
  addressBox: {
    borderWidth: 1,
    borderRadius:10,
    borderTopLeftRadius:0,
    borderColor: darkColour,
    width:350,
    height:85,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },
  childTouchable: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 35,
    borderColor: 'black',
    borderTopWidth: 2,
    borderBottomWidth: 2,
    marginTop: -2,
  },
  childBoxes: {
    borderWidth: 2, 
    borderColor: 'black', 
    height: '100%', 
    alignItems: 'center', 
    marginLeft: -2, 
    borderTopWidth: 0, 
    borderBottomWidth: 0,
  },
  childText: {
    fontFamily: 'century gothic', 
    fontSize: 15, 
    fontWeight: 'normal',
    marginTop: 6,
  },
  iconButtonStyle: {
    justifyContent:'center', 
    padding:0, 
    margin:0, 
    marginLeft: -5, 
    alignContent:'center',
  },
  birthDateText: {
    fontFamily:'century gothic', 
    color: 'white', 
    fontSize:16, 
    padding:10, 
    paddingLeft:10, 
    fontWeight:'normal'
  },
  dateTextContainer: {
    backgroundColor: darkColour, 
    width:110, 
    height:40,
    borderRadius: 10, 
    borderTopRightRadius:0,
    borderBottomRightRadius:0,
    borderWidth:1,
    borderRightWidth:0,
    borderColor: darkColour,
    marginRight: -25
  },
})

export default CompanyData;